export default "__VITE_ASSET__DRq2hq0J__"